import React from 'react';
import { Grid } from '@material-ui/core';
import { isNil, get, isEmpty } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpeningPage/messages';
import * as featureService from 'features/fflip-helpers';
import { renderStatusDecisionParties } from 'containers/PreOpeningPage/utils';
import { FEATURES } from 'features/features';
import ScheduleSend from 'images/schedule_send.svg';
import { PARTIES_CLAIM_STATUS } from 'containers/data-structure';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import { VictimType } from 'typings/globalTypes';

export interface TitleAccordionProps {
  intl: IntlShape;
  isTransactionManager: boolean;
  index: number;
  victimsEligibleToTransaction: any;
  victim: VictimType;
  isManager: boolean;
}

const StyledContainer = {
  padding: '0px 16px',
  border: '1px solid rgba(0, 129, 198, 1)',
  borderRadius: '92px',
  backgroundColor: 'rgba(227, 246, 255, 1)',
};
const StyledElement = {
  fontWeight: 700,
  fontSize: '10px',
  lineHeight: '16px',
  color: 'rgba(0, 25, 77, 1)',
  marginLeft: 3,
};
const TitleAccordion: React.FC<TitleAccordionProps> = (props): JSX.Element => {
  const {
    isTransactionManager,
    index,
    victimsEligibleToTransaction,
    victim,
  } = props;
  const eligibilityInfo =
    !isEmpty(
      victimsEligibleToTransaction.find(
        (el: any) => el.id === get(victim, 'id'),
      ),
    ) && isEmpty(get(victim, 'eligibilityTransaction', []))
      ? victimsEligibleToTransaction.find(
          (el: any) => el.id === get(victim, 'id'),
        )
      : !isEmpty(get(victim, 'eligibilityTransaction'))
      ? get(victim, 'eligibilityTransaction')
          .map((el: any) => {
            return {
              eligible:
                String(el.eligibility) === 'true' ? CHOICE.YES : CHOICE.NO,
              reason: el.reason,
            };
          })
          .find((it: any) => !it.isDeleted)
      : {};
  return (
    <Grid container direction="row" spacing={1}>
      <Grid item>
        {translate({ ...messages.victimAccordionTitle }, props, {
          number: index + 1,
        })}
      </Grid>
      {featureService.hasFeature(FEATURES.TRANSACTION) && props.isManager ? (
        <>
          <Grid item>
            {isTransactionManager &&
            !isEmpty(eligibilityInfo) &&
            isEmpty(get(victim, 'transactions', [])) ? (
              <Grid container direction="row" spacing={3}>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#0072c6',
                    }}
                  >
                    {translate(messages.titleEligibility, props) + ': '}
                    {get(eligibilityInfo, 'eligible', null) === CHOICE.YES
                      ? translate(messages.yesChoiceTitle, props)
                      : translate(messages.noChoiceTitle, props)}
                  </Typography>
                </Grid>
                {!isNil(get(eligibilityInfo, 'reason', null)) && (
                  <Grid item>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#0072c6',
                      }}
                    >
                      {translate(messages.reasonRecapTitle, props)}
                    </Typography>
                  </Grid>
                )}
                <Grid item>
                  <Typography
                    style={{
                      fontSize: '14px',
                      color: 'red',
                    }}
                  >
                    {get(eligibilityInfo, 'reason', null)}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              !isEmpty(get(victim, 'transactions', [])) && (
                <Grid item>
                  <Grid
                    style={StyledContainer}
                    container
                    direction="row"
                    alignItems="center"
                  >
                    <Grid item>
                      <img
                        style={{ marginTop: 5 }}
                        src={ScheduleSend}
                        alt="schedule"
                      />
                    </Grid>
                    <Grid item style={StyledElement}>
                      {get(
                        victim,
                        'transactions[0].transactionStatus.title',
                        [],
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </>
      ) : (
        <>
          <Grid item>
            {get(victim, 'decision.status', '') ===
            PARTIES_CLAIM_STATUS.REJECTED ? (
              <Grid container direction="row" spacing={3}>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#0072c6',
                    }}
                  >
                    {translate(messages.statusRecapTitle, props)}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: '14px',
                      color: 'red',
                    }}
                  >
                    {renderStatusDecisionParties(
                      get(victim, 'decision.status', ''),
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#0072c6',
                    }}
                  >
                    {translate(messages.reasonRecapTitle, props)}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      fontSize: '14px',
                      color: 'red',
                    }}
                  >
                    {get(victim, 'decision.reason', '')}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <>
                {get(victim, 'decision.reason', '') && (
                  <Grid container direction="row" spacing={3}>
                    <Grid item>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          color: '#0072c6',
                        }}
                      >
                        {translate(messages.statusRecapTitle, props)}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography style={{ fontSize: '14px' }}>
                        {renderStatusDecisionParties(
                          get(victim, 'decision.status', ''),
                        )}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          color: '#0072c6',
                        }}
                      >
                        {translate(messages.comment, props) + ' :'}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        style={{
                          fontSize: '14px',
                          color: 'black',
                        }}
                      >
                        {get(victim, 'decision.reason', '')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </Grid>
          <Grid item>
            {victim?.isFromSagis && (
              <Typography
                style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: 'black',
                }}
              >
                {translate(messages.migrateVictimTitle, props)}
              </Typography>
            )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default injectIntl(TitleAccordion);
